/**
 * Favoritos del usuario (pinned forms).
 *
 * Estado: `formIds` es un Set serializable (array) de IDs de Form que el
 * usuario ha marcado como favorito. La lista de Form completos vive en
 * `items` para que el drawer pueda renderlos sin re-fetch del catálogo.
 */
export const state = () => ({
	items: [],
});

export const mutations = {
	set(state, payload) {
		state.items = Array.isArray(payload) ? payload : [];
	},
	add(state, form) {
		if (!form || !form.ID) return;
		if (!state.items.find((f) => f.ID === form.ID)) {
			state.items = [...state.items, form];
		}
	},
	remove(state, formID) {
		state.items = state.items.filter((f) => f.ID !== formID);
	},
	clear(state) {
		state.items = [];
	},
};

export const getters = {
	items(state) {
		return state.items || [];
	},
	formIds(state) {
		return new Set((state.items || []).map((f) => f.ID));
	},
	isFavorite: (state) => (formID) => {
		return (state.items || []).some((f) => f.ID === formID);
	},
};

export const actions = {
	async fetch({ commit }) {
		try {
			const token = window.localStorage.getItem("auth._token.local");
			const res = await this.$axios.get("/favorites", {
				headers: { Authorization: token },
			});
			const items = Array.isArray(res.data) ? res.data : [];
			// The API returns Favorite{ID, UserID, FormID, Form{...}} rows;
			// the drawer wants the Form objects directly.
			commit(
				"set",
				items
					.map((fav) => fav && fav.Form)
					.filter((f) => f && f.link),
			);
		} catch (err) {
			console.warn("favorites/fetch failed", err);
			commit("set", []);
		}
	},
	async toggle({ commit, getters }, form) {
		if (!form || !form.ID) return;
		const wasFav = getters.isFavorite(form.ID);
		// Optimistic update — revert on error.
		if (wasFav) commit("remove", form.ID);
		else commit("add", form);

		try {
			const token = window.localStorage.getItem("auth._token.local");
			await this.$axios.post(
				"/favorites/toggle",
				{ form_id: form.ID },
				{ headers: { Authorization: token } },
			);
		} catch (err) {
			console.error("favorites/toggle failed; reverting", err);
			if (wasFav) commit("add", form);
			else commit("remove", form.ID);
		}
	},
};
